jQuery(document).ready(function($) {
	const base = "gc-account";

	function update_account_type() {   
		if ($('.gp-register').length) {
			let type = $('.gp-register input[name=type]:checked').val();
			
			if(type == 'company') {
				$(`.${base}__input-wrapper`).hide().find('input').removeAttr('required');
				$(`.${base}__company`).show().find('input').attr('required',true);
			} else {
				$(`.${base}__input-wrapper`).hide().find('input').removeAttr('required');
				$(`.${base}__customer`).show().find('input').attr('required',true);          
			}
		}
	}

	update_account_type();

	$('.gp-register input[name=type]').on('change',function(e) {        
		update_account_type();
	});
	
	$('.gp-register form').submit(function(e) {
		e.preventDefault();
		$(`.${base}__submit`).prop('disabled', true);
		$(`.${base}__message`).html('').hide();

		const formData = $(this).serialize();
		const url = $(this).attr('action');
		$.ajax({
			url : url,
			type: 'POST',
			data : formData
		}).done(function(responseRaw) {
			$(`.${base}__submit`).prop('disabled', false);
			let response = JSON.parse(responseRaw);
			
			if(response.success) {
				window.location.replace('/');
			} else {
				$(`.${base}__message`).html(response.message).show();
			}
		});
	});
});